module.exports = __webpack_public_path__ + "static/media/watch3.29d8948e.jpg";